// Angular modules
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi }           from '@angular/common/http';
import { HttpClientModule }     from '@angular/common/http';
import { APP_INITIALIZER }      from '@angular/core';
import { NgModule }             from '@angular/core';
import { Injector }             from '@angular/core';
import { BrowserModule, platformBrowser }        from '@angular/platform-browser';
import { DatePipe }             from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// External modules
import { TranslateService }     from '@ngx-translate/core';
import { TranslateModule }      from '@ngx-translate/core';
import { TranslateLoader }      from '@ngx-translate/core';
import { TranslateHttpLoader }  from '@ngx-translate/http-loader';
import { AngularSvgIconModule } from 'angular-svg-icon';

// Internal modules
import { AppRoutingModule }     from './app-routing.module';
import { SharedModule }         from './shared/shared.module';
import { StaticModule }         from './static/static.module';

// Services
import { AppService }           from '@services/app.service';
import { StoreService }         from '@services/store.service';

// Components
import { AppComponent }         from './app.component';

// Factories
import { appInitFactory }       from '@factories/app-init.factory';
import { ToastrModule } from 'ngx-toastr';
import { Loader } from "@googlemaps/js-api-loader";
import { NgxGpAutocompleteModule } from "@angular-magic/ngx-gp-autocomplete";
import { ConfigService } from '@services/config.service';
import { AuthInterceptor } from '@services/auth.interceptor';


export function initializeApp(configService: ConfigService) {
  return (): Promise<void> => {
    return new Promise((resolve) => {
      configService.setBaseUrl();
      resolve();
    });
  };
}


@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        BrowserModule,
        // External modules
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        AngularSvgIconModule.forRoot(),
        // Internal modules
        SharedModule,
        StaticModule,
        AppRoutingModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-right'
        }),
        NgxGpAutocompleteModule], providers: [
        // External modules
        {
            provide: APP_INITIALIZER,
            useFactory: appInitFactory,
            deps: [TranslateService, Injector, ConfigService],
            multi: true
        },
        ConfigService,
        // {
        //   provide: Loader,
        //   useValue: new Loader({
        //     apiKey: 'AIzaSyCBMGfRHmJc2Lpznbibt_pT9UADrY8ubug',
        //     libraries: ['places']
        //   })
        // },
        // Services
        AppService,
        StoreService,
        // Pipes
        DatePipe,
        // Guards
        // Interceptors
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }

export function createTranslateLoader(http : HttpClient)
{
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}